import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  Inject,
  OnDestroy,
  OnInit,
  Renderer2,
  Optional,
  signal,
  ViewChild,
  Input,
} from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserTypeEnum } from '@app/enum/UserTypeEnum';
import { DocumentService, UserService } from '@app/shared/services';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Subscription, timer } from 'rxjs';
import * as loginSelectors from './../../root-store/login-store/login.selector';
import moment from 'moment';
import { SecureAccountCompletedComponent } from '../home-page/components/dialogs/secure-account-completed/secure-account-completed.component';
import { RootStoreState, loginStoreActions } from '@app/root-store';
import { AddressFormMapping, GoogleMapsAutocompleteService } from '@app/shared/services/google-maps-autocomplete/google-maps-autocomplete.service';
import { debounceTime, tap, shareReplay } from 'rxjs/operators';
import { birthdateValidator, prefixes, suffixes } from '@app/shared/utils';
import { BsFileUploadNewComponent } from '../bs-file-upload-new/bs-file-upload-new.component';
import { FamilyTreeService } from '@app/shared/services/family-tree/family-tree.service';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'profile-stepper-bar',
  templateUrl: './profile-stepper-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileStepperBarComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('streetAddressInput', { static: false }) streetAddressInput: ElementRef;
  private renderer = inject(Renderer2);

  user$;
  cityData = [];
  stateData = [];
  moment = moment;
  countryData = [];
  profile_image_url;
  screenWidth: number;
  autocomplete = null;
  todayDate = new Date();
  accountSecured = false;
  ProfessionaltypeData = [];
  makeselectdisable = false;
  isUserIsProfessional = true;
  isCityDataLoading = false;
  isStateDataLoading = false;
  userEditProfileForm: FormGroup;
  subscription = new Subscription();
  professionalUserType = UserTypeEnum.Professional;

  genderHasValue = signal(false);
  prefixes = prefixes;
  suffixes = suffixes;
  @Input() isAccountSettingsPage: boolean = false;
  userDetails = null;
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private toastr: ToastrService,
    private store$: Store<RootStoreState.State>,
    private _fb: FormBuilder,
    @Optional() public dialogRef: MatDialogRef<ProfileStepperBarComponent>,
    private googleMapsService: GoogleMapsAutocompleteService,
    private store: Store,
    private _familyTreeService: FamilyTreeService,
    private documentService: DocumentService,
    private userService: UserService,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.loadGoogleFonts();
    this.screenWidth = window.innerWidth;
    if (this.data?.userData?.id) {
      this.user$ = this._familyTreeService.getFamilyTreeUserDetails(this.data.userData.id).pipe(shareReplay(1));
    } else {
      this.user$ = this.store.select(loginSelectors.getCurrentUserDetailsAll);
    }

    this.userEditProfileForm = this._fb.group({
      first_name: ['', []],
      middle_name: [''],
      last_name: ['', []],
      your_self: [''],
      birthdate: ['', [birthdateValidator]],
      country: ['', []],
      state: ['', []],
      zip: [''],
      city: ['', []],
      street: ['', []],
      gender: [''],
      phone_no: ['', []],
      user_email: [''],
      contact_email: ['', []],
      professional_type_id: [''],
      prefix: [''],
      suffix: [''],
    });

    if (this.data?.editType === 'contactInfo' && this.data?.viewModeOnly) {
      this.userEditProfileForm.disable();
    } else {
      this.userEditProfileForm.controls.user_email.disable();
    }
    // this.cd.detectChanges();

    if (this.data?.editType == 'contactInfo' || this.isAccountSettingsPage) this.getAllCountries();

    this.subscription.add(
      this.userEditProfileForm.controls['phone_no'].valueChanges.subscribe((val) => {
        var ch = val.split('');
        let newCh = '';
        ch.forEach((element) => {
          if (!isNaN(element) || element == '+') {
            newCh = newCh + element;
          }
        });
        if (val != newCh) {
          this.userEditProfileForm.controls['phone_no'].setValue(newCh);
        }
      })
    );

    if (!this.data?.userData?.id) {
      this.subscription.add(
        this.store
          .pipe(select(loginSelectors.getCurrentUserFullDetails))
          .pipe(
            tap((result) => {
              if (this.data?.editType == 'basicInfo' || (this.isAccountSettingsPage && result)) {
                this.subscription.add(
                  timer(0).subscribe(() => {
                    this.userEditProfileForm.controls['prefix'].setValue(result.prefix);
                    this.userEditProfileForm.controls['suffix'].setValue(result.suffix);
                    this.cd.detectChanges();
                  })
                );
              }
            })
          )
          .subscribe((result) => {
            if (result) {
              this.userDetails = result;
              if (result?.user_type == UserTypeEnum.Professional) {
                this.isUserIsProfessional = true;
                this.userEditProfileForm.controls.professional_type_id.setValidators([Validators.required]);
                this.subscription.add(
                  this.store.select(loginSelectors.getCurrentUserDetailsAll).subscribe(
                    (res) => {
                      if (res?.professional_type_id) {
                        this.makeselectdisable = true;
                      }
                    },
                    (error) => {}
                  )
                );
                this.getVaultCategories();
              } else {
                this.isUserIsProfessional = false;
              }
              if (this.data?.editType == 'contactInfo' || (this.isAccountSettingsPage && result.country)) {
                this.userEditProfileForm.get('country').setValue(result.country);
              }
              if (this.data?.editType == 'contactInfo' || (this.isAccountSettingsPage && result.state)) {
                this.userEditProfileForm.get('state').setValue(result.state);
              }
            }
          })
      );
    }

    this.subscription.add(
      this.userEditProfileForm
        .get('country')
        .valueChanges.pipe(debounceTime(300))
        .subscribe(() => {
          if (typeof (window as any).google !== 'undefined') {
            this.cleanupAutocomplete();
            this.initializeAddresseAutocomplete();
          }
        })
    );
  }

  ngAfterViewInit() {
    if (!!this.userEditProfileForm?.controls['gender']) {
      this.subscription.add(
        this.userEditProfileForm.controls['gender'].valueChanges.subscribe((value) => {
          this.genderHasValue.set(!!value);
        })
      );
    }
    if (this.isAccountSettingsPage) {
      this.userEditProfileForm.get('city').setValue(this.userDetails?.city ?? '');
      this.userEditProfileForm.get('street').setValue(this.userDetails?.street ?? '');
      this.userEditProfileForm.get('zip').setValue(this.userDetails?.zip ?? '');
      this.userEditProfileForm.get('country').setValue(this.userDetails?.country ?? '');
      this.userEditProfileForm.get('state').setValue(this.userDetails?.state ?? '');
      this.userEditProfileForm.get('prefix').setValue(this.userDetails?.prefix ?? '');
      this.userEditProfileForm.get('suffix').setValue(this.userDetails?.suffix ?? '');
      this.userEditProfileForm.get('phone_no').setValue(this.userDetails?.phone_no ?? '');
      this.userEditProfileForm.get('contact_email').setValue(this.userDetails?.contact_email ?? '');
      this.userEditProfileForm.get('first_name').setValue(this.userDetails?.first_name ?? '');
      this.userEditProfileForm.get('last_name').setValue(this.userDetails?.last_name ?? '');
      this.userEditProfileForm.get('middle_name').setValue(this.userDetails?.middle_name ?? '');
      this.userEditProfileForm.get('your_self').setValue(this.userDetails?.your_self ?? '');
      this.userEditProfileForm.get('birthdate').setValue(this.userDetails?.birthdate ?? '');

      if (this.data?.editType === 'contactInfo' && this.data?.viewModeOnly) {
        this.userEditProfileForm.disable();
      }
    }

    this.userService
      .loadGoogleMapsApi()
      .then(() => {
        setTimeout(() => {
          this.cleanupAutocomplete();
          this.initializeAddresseAutocomplete();
        }, 1500);
      })
      .catch((error) => console.error('Error loading Google Maps API:', error));
  }

  async getAllCountries() {
    this.subscription.add(
      (await this.userService.getCountriesData()).subscribe(
        (response) => {
          this.countryData = [...response];
          this.cd.detectChanges();
          if (this.userEditProfileForm.get('country').value) {
            let countryCode = this.filterCountriesAndStatesByName(this.countryData, this.userEditProfileForm.get('country').value);
            this.getStatesByCountryCode(countryCode);
          }
        },
        (error: any) => {
          this.toastr.error('Error occurred while getting a list of countries');
        }
      )
    );
  }

  async getStatesByCountryCode(countryCode) {
    this.isStateDataLoading = true;
    this.subscription.add(
      (await this.userService.getStatesByCountryCode(countryCode)).subscribe(
        (response) => {
          this.stateData = [...response];
          this.isStateDataLoading = false;
          this.cd.detectChanges();
          if (this.userEditProfileForm.get('state').value) {
            const stateCode = this.filterCountriesAndStatesByName(this.stateData, this.userEditProfileForm.get('state').value);
            if (stateCode.length > 0) {
              this.getCountriesDataByCountryAndStateCode(countryCode, stateCode);
            }
          }
        },
        (error: any) => {
          this.toastr.error('Error occurred while getting a list of states');
        }
      )
    );
  }

  async getCountriesDataByCountryAndStateCode(countryCode, stateCode) {
    this.isCityDataLoading = true;
    this.subscription.add(
      (await this.userService.getCountriesDataByCountryAndStateCode(countryCode, stateCode)).subscribe(
        (response) => {
          this.cityData = [...response];
          this.isCityDataLoading = false;
          this.cd.detectChanges();
        },
        (error: any) => {
          this.toastr.error('Error occurred while getting a list of cities');
        }
      )
    );
  }

  getVaultCategories() {
    this.subscription.add(
      this.documentService.getVaultCategories().subscribe(
        (res) => {
          this.ProfessionaltypeData = [];
          res.forEach((element, index) => {
            if (element.id == 2 || element.id == 8 || element.id == 3 || element.id == 4 || element.id == 5) {
              if (element.id == 8) {
                element.name = 'Concierge';
              }
              this.ProfessionaltypeData.push(element);
            }
          });
          this.cd.detectChanges();
        },
        (error) => {}
      )
    );
  }

  initializeAddresseAutocomplete() {
    if (!this.streetAddressInput.nativeElement) {
      return;
    }

    const formMapping: AddressFormMapping = {
      street: 'street',
      country: 'country',
      state: 'state',
      city: 'city',
      zip: 'zip',
    };

    // Initialize new autocomplete
    this.autocomplete = this.googleMapsService.initializeAutocomplete(
      this.streetAddressInput.nativeElement,
      this.userEditProfileForm,
      formMapping,
      this.countryData,
      this.userEditProfileForm.get('country').value,
      (address) => {
        const countryCode = address.country;
        const stateCode = address.administrative_area_level_1;
        if (countryCode) {
          this.getStatesByCountryCode(countryCode);
        }
      }
    );
  }

  async selectEvent(itemSelected, countrycode?: string, stateCode?: string) {
    if (itemSelected.source._selected && itemSelected.source.value) {
      let countryFormControl = this.userEditProfileForm.get('country').value;
      let stateFormControl = this.userEditProfileForm.get('state').value;
      if (countrycode && stateCode) {
        // this.userEditProfileForm.get('state').setValue('');
        this.userEditProfileForm.get('city').setValue('');
        this.cityData = [];
        this.getCountriesDataByCountryAndStateCode(countrycode, stateCode);
      } else if (countrycode) {
        this.userEditProfileForm.get('state').setValue('');
        this.userEditProfileForm.get('city').setValue('');
        this.userEditProfileForm.get('street').setValue('');
        this.userEditProfileForm.get('zip').setValue('');
        this.stateData = [];
        this.cityData = [];
        this.getStatesByCountryCode(countrycode);
      }
    }
  }

  updateUserInfo(user) {
    let registeredCountry = false;
    const form = this.userEditProfileForm;
    if (this.data?.editType == 'contactInfo' || !this.data?.editType) {
      form.get('state').setValidators([Validators.maxLength(100)]);
      form.get('city').setValidators([Validators.maxLength(100)]);
      form.get('country').setValidators([Validators.maxLength(100)]);
      form.get('street').setValidators([Validators.maxLength(100)]);
      form.get('contact_email').setValidators([Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,25}$')]);

      form.get('state').updateValueAndValidity();
      form.get('city').updateValueAndValidity();
      form.get('country').updateValueAndValidity();
      form.get('street').updateValueAndValidity();
      form.get('contact_email').updateValueAndValidity();

      if (form.get('phone_no').value) {
        // form.get('phone_no').setValidators(validatePhoneNumber());
        form.get('phone_no').setValidators([Validators.maxLength(15)]);
        form.get('phone_no').updateValueAndValidity();
      }
      if (this.countryData.length) {
        registeredCountry = this.countryData.find((element) => {
          if (form.get('country').value && element.name.trim().toLowerCase() == form.get('country').value.trim().toLowerCase()) {
            form.get('country').patchValue(element.name.trim());
            return true;
          }
          return false;
        });
        if (!registeredCountry && form.get('country').value) {
          form.controls['country'].markAsTouched();
          form.controls['country'].setErrors({});
        }
      }
    }
    if (this.data?.editType == 'basicInfo' || !this.data?.editType) {
      form.get('first_name').setValidators([Validators.required]);
      form.get('last_name').setValidators([Validators.required]);
      form.get('first_name').updateValueAndValidity();
      form.get('last_name').updateValueAndValidity();
    }
    if (!!this.isAccountSettingsPage) {
      this.userEditProfileForm.removeControl('gender');
    } else {
      form.get('gender').setValidators([Validators.required]);
    }
    this.userEditProfileForm.updateValueAndValidity();

    if (!this.userEditProfileForm.valid) return;

    let request;
    if (this.data?.editType == 'basicInfo' || !this.data?.editType) {
      request = {
        first_name: this.userEditProfileForm.controls['first_name'].value,
        last_name: this.userEditProfileForm.controls['last_name'].value,
        middle_name: this.userEditProfileForm.controls['middle_name'].value,
        your_self: this.userEditProfileForm.controls['your_self'].value,
        birthdate: this.userEditProfileForm.controls['birthdate'].value,
        prefix: this.userEditProfileForm.controls['prefix'].value,
        suffix: this.userEditProfileForm.controls['suffix'].value,
        ...(user.user_type != this.professionalUserType && { gender: this.userEditProfileForm.controls['gender'].value || null }),
        ...(user.user_type == this.professionalUserType && { professional_type_id: this.userEditProfileForm.controls['professional_type_id'].value }),
      };
      if (request.birthdate) {
        // const date = new Date(this.userEditProfileForm.controls['birthdate'].value);
        // let dateValue = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        // let monthValue = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        // const newBirthdate = `${date.getFullYear()}-${monthValue}-${dateValue}`;
        // request.birthdate = newBirthdate;
      } else {
        request.birthdate = null; //if birthdate was an empty string, make it null for DB.
      }
    }
    if (this.data?.editType == 'contactInfo' || !this.data?.editType) {
      const contactInfo = {
        contact_email: this.userEditProfileForm.controls['contact_email'].value || null,
        phone_no: this.userEditProfileForm.controls['phone_no'].value || null,
        state: this.userEditProfileForm.controls['state'].value || null,
        city: this.userEditProfileForm.controls['city'].value || null,
        street: this.userEditProfileForm.controls['street'].value || null,
        zip: this.userEditProfileForm.controls['zip'].value || null,
        country: this.userEditProfileForm.controls['country'].value || null,
      };
      if (this.isAccountSettingsPage) {
        request = {
          ...request,
          ...contactInfo,
        };
      } else {
        request = {
          ...contactInfo,
        };
      }
    }

    request.guidance_status = 'done';

    if (user?.user_type != this.professionalUserType && request?.professional_type_id) {
      delete request['professional_type_id'];
    }
    this.subscription.add(
      this.userService.updateUser(request).subscribe(
        (data) => {
          this.user$ = this.store.select(loginSelectors.getCurrentUserDetailsAll);

          this.subscription.add(
            this.user$.subscribe((data) => {
              this.accountSecured = data?.mfa_enabled && data?.profile_image_url && data?.city && data?.country ? true : false;
            })
          );

          // if (user.user_type != this.professionalUserType) {
          if (this.data?.triggeredFrom == 'continueBtn' && this.accountSecured) {
            this.secureAccountCompleted();
          } else if (!this.isAccountSettingsPage) {
            this.dialogRef.close({
              confirmation: true,
            });
          }
          // }
          this.toastr.success('Profile updated');
          this.cd.detectChanges();
        },
        (error: any) => {
          this.toastr.error(error.error.message);
        }
      )
    );
  }

  secureAccountCompleted() {
    this.dialog.closeAll();
    const modalRef = this.dialog.open(SecureAccountCompletedComponent, {
      autoFocus: false,
      panelClass: 'full-window-dialog-2',
    });
    this.subscription.add(
      modalRef.afterClosed().subscribe((data) => {
        if (data) {
          this.store$.dispatch(new loginStoreActions.LoginRequestAction());
        }
      })
    );
  }

  filterCountriesAndStatesByName(data, name) {
    const filteredCountries = data.filter((country) => country.name === name);
    return filteredCountries.map((country) => country.isoCode);
  }

  resetValue(type) {
    if (type == 'state') this.cityData = [];
    if (type == 'country') {
      this.cityData = [];
      this.stateData = [];
    }
    this.cd.detectChanges();
  }

  cleanupAutocomplete() {
    if (this.autocomplete && this.streetAddressInput?.nativeElement) {
      (window as any).google.maps.event.clearInstanceListeners(this.streetAddressInput.nativeElement);
      this.autocomplete = null;
      this.cd.detectChanges();
    }
  }

  logDate(e) {}

  closeDialog(isFinish?: boolean) {
    this.dialogRef.close({ confirmation: false });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  handleDateChange(value) {
    // this.userEditProfileForm.controls['birthdate'].setValue(value);
  }
  handleDateChange2(value) {
    this.userEditProfileForm.controls['birthdate'].setValue(value);
  }
  pendingImgSrc = '';
  imageChangedEvent = '';
  format = null;
  isPendingImg = false;
  fileChangeEvent(event: any): void {
    const file = event.target.files && event.target.files[0];
    if (file) {
      if (file.type.indexOf('image') > -1) {
        this.format = 'image';
        this.imageChangedEvent = event;
        this.cd.markForCheck();
      } else if (file.type.indexOf('video') > -1) {
        this.format = 'video';
        this.toastr.error('Invalid image type.');
      }

      if (file.type.indexOf('image') > -1) {
        const modalRef2 = this.dialog.open(BsFileUploadNewComponent, {
          data: {
            videoMimeType: file.type,
            format: this.format,
            type: 'profile',
            title: 'Upload Profile Picture',
            image: 'profile',
            imageChangedEvent: this.imageChangedEvent,
          },
          autoFocus: false,
          panelClass: 'full-window-dialog-2',
        });

        this.subscription.add(
          this.subscription.add(
            modalRef2.afterClosed().subscribe(async (upload_promise: any) => {
              await upload_promise;
              this.store$.dispatch(new loginStoreActions.LoginRequestAction());
            })
          )
        );
      }
    }
  }

  loadGoogleFonts() {
    // Create the link element
    const link = this.renderer.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200';

    // Append the link to the head of the document
    this.renderer.appendChild(document.head, link);
  }
}
